<template>
  <div>
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Danh sách hợp đồng</h1>
      <div class="float-right btn-group">
        <DraggableTable
          :naming="$route.name"
          v-model="fieldsTable"
          @change="filterTable = $event"
        />
      </div>
    </div>
    <div class="p-10  pt-15 b-t-1-869fb229">
      <div class="card-header m-b-10">
        <form class="box-search" @submit="submitForm">
          <div class="form-group">
            <input
              type="text"
              v-model.trim="search.keySearch"
              class="form-control f12 hc-37"
              placeholder="Từ khóa"
            />
          </div>
          <div class="form-group">
            <Select2
              placeholder="Trạng thái"
              v-model="search.contractStateAgency"
              :options="Config.contractStatus">
            </Select2>
          </div>
          <div class="form-group form-group-action">
            <button
              @click="submitForm"
              class="pt-2 mr-2 btn btn-primary hc-37"
              data-toggle="tooltip"
              data-placement="top"
              title="Lọc"
            >
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Lọc
            </button>
            <button
              @click="removeForm"
              type="button"
              class="pt-2 mr-2 btn btn-outline-light hc-37"
              data-toggle="tooltip"
              data-placement="top"
              title="Bỏ lọc"
            >
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Bỏ lọc
            </button>
          </div>
        </form>
      </div>
      <div class="">
        <div class="tab-content" id="nav-tabContent">
          <div class="p-10">
            <b-table
              :busy.sync="loading"
              sticky-header
              hover
              responsive
              :items="list"
              :fields="filterTable"
              :fixed="true"
              :bordered="true"
            >
              <template #table-busy>
                <div class="my-2 text-center">
                  <b-spinner class="align-middle"></b-spinner>
                </div>
              </template>
              <template #cell(index)="data">
                {{ getIndex(data.index) }}
              </template>
              <template #cell(code)="{item}">
                <router-link :to="'/contract/detail/' + item.id">{{ item.code }}</router-link>
              </template>
              <template #cell(merchantData)="{item}">
                {{ item.merchantData.merchantName }}
              </template>
              <template #cell(time)="{item}">
                <p v-if="item.dateCreate">Tạo: {{item.dateCreate | formatDateTime7}}</p>
                <p v-if="item.dateSign">Ký: {{item.dateSign | formatDateTime7}}</p>
                <p v-if="item.dateCancel">Huỷ: {{item.dateCancel | formatDateTime7}}</p>
              </template>
              <template #cell(numDevices)="{item}">
                Số lượng: {{ item.numDevices }}
              </template>
              <template #cell(statusReceipt)="{item}">
                <Status :value="item.statusReceipt && item.statusReceipt.length && item.statusReceipt[0]" :config="Config.receiptStatus"/>
              </template>
              <template #cell(status)="{item}">
                <Status :value="item.contractStateAgency" :config="Config.contractStatus"/>
              </template>
              <template #cell(action)="{item}">
                <button
                    class="btn btn-primary btn-sm mr-2"
                    @click="$router.push('/contract/detail/' + item.id)"
                  >
                  <i class="bx bx-detail"></i>
                </button>
              </template>
            </b-table>
          </div>
        </div>
      </div>
      <div class="pagination-bottom mr-5">
        <b-pagination
          v-model="search.page"
          :total-rows="pagination.total"
          :per-page="search.limit"
          class="mr-2 fl-right mr-4"
        ></b-pagination>
      </div>
    </div>
    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true">
    </VueLoadingOverlay>
  </div>
</template>
<script>
import { ContractService } from '@/services/contract.service'
const fieldsTable = [
  { key: 'index', label: 'STT', class: 'text-center' },
  { key: 'code', label: 'Mã hợp đồng' },
  { key: 'merchantData', label: 'Merchant' },
  { key: 'time', label: 'Thời gian' },
  { key: 'numDevices', label: 'Thiết bị' },
  { key: 'status', label: 'Trạng thái' },
  { key: 'statusReceipt', label: 'Phiếu thu' },
  { key: 'action', label: 'Thao tác', fixIndex: 999, class: 'text-center' }
]
export default {
  name: 'Contract',
  components: {},
  data () {
    return {
      loading: false,
      showLoading: false,
      fieldsTable,
      filterTable: fieldsTable,
      list: [],
      search: {
        page: 1,
        limit: 20
      },
      pagination: {
        total: 0
      }
    }
  },
  async mounted () {
    this.fetchData()
  },
  watch: {
    'search.limit': function () {
      this.fetchData()
    },
    'search.page': function () {
      this.fetchData()
    }
  },
  computed: {},
  methods: {
    async submitForm (event) {
      event.preventDefault()
      this.fetchData()
    },
    async removeForm () {
      this.search = {
        limit: 20,
        page: 1
      }
      await this.fetchData()
    },

    // Dữ liệu bảng
    async fetchData () {
      try {
        this.loading = true
        const params = { ...this.search }
        params.agentId = this.dataUser.agentId
        params.groupService = 'PAYMENT'
        params.serviceTypes = ['MPOS']
        const data = await ContractService.fetch(params)
        if (data.success) {
          this.list = data.data.contractList
          this.pagination.total = data.totalPage.total ?? 0
        } else {
          this.list = []
          this.pagination.total = 0
        }
      } catch (error) {
        this.list = []
        this.pagination.total = 0
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.breadcrumb-area {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.box-search {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.form-group {
  margin-bottom: 10px;
  min-width: 200px;
}

.form-group-action {
  display: flex;
  align-items: flex-end;
}

.pagination-bottom {
  display: flex;
  justify-content: flex-end;
  margin-right: 10px;
}
</style>
